import type { Item, User } from './api';
import mockAudio from '../гарна сука.mp3';

// Simple deterministic PRNG for reproducibility
function mulberry32(seed: number) {
	let t = seed >>> 0;
	return () => {
		t += 0x6D2B79F5;
		let r = Math.imul(t ^ (t >>> 15), 1 | t);
		r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
		return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
	};
}

const genres = ['trap', 'drill', 'pop', 'hyperpop', 'rnb', 'house', 'techno', 'ukrainian', 'phonk', 'lofi'];
const keys = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
const categories: Item['category'][] = ['beat', 'cover', 'feature', 'mix', 'kit', 'service'];

function pick<T>(rng: () => number, arr: T[]): T {
	return arr[Math.floor(rng() * arr.length)];
}

function sentence(rng: () => number, words: number): string {
	const pool = ['energy', 'melodic', 'dark', 'ambient', 'emotional', '808', 'clean', 'vocal', 'space', 'retro', 'vibe', 'club', 'radio', 'fast', 'slow', 'bouncy'];
	const parts: string[] = [];
	for (let i = 0; i < words; i++) parts.push(pick(rng, pool));
	return parts.join(' ');
}

export const mockUsers: User[] = Array.from({ length: 24 }).map((_, i) => {
	const first = ['Alex', 'Max', 'Ihor', 'Oleh', 'Sofiia', 'Nastia', 'Dima', 'Serhii', 'Yana', 'Andrii'][i % 10];
	const last = ['Ivanov', 'Kovalenko', 'Shevchenko', 'Tkachenko', 'Horban', 'Melnyk'][i % 6];
	return {
		id: i + 1,
		telegram_id: 100000 + i,
		username: `${first.toLowerCase()}_${last.toLowerCase()}`,
		first_name: first,
		last_name: last,
		language: 'uk',
		is_creator: true,
		created_at: new Date(Date.now() - i * 86400000).toISOString(),
	};
});

function buildPreviewUrl(_id: string): string {
	// Placeholder audio preview
	return mockAudio;
}

function buildCoverUrl(i: number): string {
	// Royalty-free placeholder images
	const pics = [
		'https://images.unsplash.com/photo-1511379938547-c1f69419868d?q=80&w=800&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=800&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1519666213635-f93adac3c5fc?q=80&w=800&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1506157786151-b8491531f063?q=80&w=800&auto=format&fit=crop',
	];
	return pics[i % pics.length];
}

function buildAvatarUrl(i: number): string {
	const avatars = [
		'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=200&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=200&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1527980965255-d3b416303d12?q=80&w=200&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=200&auto=format&fit=crop',
		'https://images.unsplash.com/photo-1633332755192-727a05c4013d?q=80&w=200&auto=format&fit=crop',
	];
	return avatars[i % avatars.length];
}

export const mockItems: Item[] = Array.from({ length: 120 }).map((_, i) => {
	const rng = mulberry32(2000 + i);
	const cat = pick(rng, categories);
	const creator = mockUsers[i % mockUsers.length];
	const bpm = Math.floor(70 + rng() * 100);
	const price = Math.random() < 0.25 ? 0 : Math.floor(50 + rng() * 950);
	const id = `mock_${i + 1}`;
	return {
		id,
		creator_id: creator.id,
		category: cat,
		title: `${cat.toUpperCase()} ${sentence(rng, 2)}`,
		description: sentence(rng, 8),
		price_uah: price,
		tags: [pick(rng, genres), pick(rng, genres), `${bpm}bpm`],
		bpm,
		key: `${pick(rng, keys)}${rng() > 0.5 ? 'm' : ''}`,
		formats: [
			{ id: 'mp3', price: Math.max(0, Math.floor(price * 0.3)) },
			{ id: 'wav', price: Math.max(0, Math.floor(price * 0.6)) },
			{ id: 'stems', price: Math.max(0, Math.floor(price * 1.0)) },
		],
		preview_url: buildPreviewUrl(id),
		media_url: buildPreviewUrl(id),
		cover_url: buildCoverUrl(i),
		is_exclusive: rng() > 0.9,
		status: 'active',
		created_at: new Date(Date.now() - i * 3600_000).toISOString(),
		creator: {
			id: creator.id,
			name: `${creator.first_name} ${creator.last_name}`,
			username: creator.username,
			avatar: buildAvatarUrl(creator.id),
		},
		stats: { likes: Math.floor(rng() * 5000), plays: Math.floor(rng() * 50000) },
	};
});

export const devUser: User = {
	id: 9999,
	telegram_id: 999999,
	username: 'dev_user',
	first_name: 'Developer',
	last_name: 'Mode',
	language: 'uk',
	is_creator: true,
	created_at: new Date().toISOString(),
};

export function searchMock(query: string, filters?: Record<string, unknown>) {
	const q = query.trim().toLowerCase();
	let data = mockItems.filter((it) =>
		[it.title, it.description, it.creator?.name || '', (it.tags || []).join(' '), it.category]
			.join(' ')
			.toLowerCase()
			.includes(q)
	);

  if (filters) {
    if ((filters as any)?.price_type === 'free') data = data.filter((i) => i.price_uah === 0);
    if ((filters as any)?.genre) {
        const g = String((filters as any).genre).toLowerCase();
        data = data.filter((i) => i.tags?.some((t) => t.toLowerCase() === g));
    }
  }
	const related_queries = genres
		.filter((g) => g.includes(q) && g !== q)
		.slice(0, 5);
	const corrected_query = q.length > 3 && q.endsWith('k') ? q.slice(0, -1) : undefined;
	const similar_items = mockItems.slice(0, 8);
	return { data, corrected_query, original_query: query, related_queries, similar_items };
}

export function getSimilarItems(itemId: string, limit = 10) {
	const idx = mockItems.findIndex((i) => i.id === itemId);
	if (idx < 0) return { data: mockItems.slice(0, limit), total: limit, page: 1, per_page: limit };
	const base = Math.max(0, idx - 5);
	const data = mockItems.slice(base, base + limit);
	return { data, total: data.length, page: 1, per_page: limit };
}

export function getCreatorsByRole(role?: string, limit = 10): { data: User[] } {
	const roleMap: Record<string, number[]> = {
		performer: [0, 3, 6, 9, 12, 15, 18, 21],
		beatmaker: [1, 4, 7, 10, 13, 16, 19, 22],
		designer: [2, 5, 8, 11, 14, 17, 20, 23],
		producer: [0, 2, 4, 6, 8, 10, 12, 14],
	};
	let list = mockUsers;
	if (role && roleMap[role]) {
		list = roleMap[role].map((i) => mockUsers[i % mockUsers.length]);
	}
	// Add avatars to users
	return { data: list.slice(0, limit).map((user, idx) => ({
		...user,
		avatar: buildAvatarUrl(user.id || idx),
	})) };
}
